import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './index.css';

class Modal extends Component {
  _handleClose = () => {
    const { onToggle } = this.props;
    onToggle && onToggle();
  };

  render() {
    const { children, enableTopRightClose, header, theme } = this.props;
    const modalCSS = cn(
      'modal',
      theme ? theme.map(css => `modal--${css}`).join(' ') : ''
    );

    return (
      <div className={modalCSS}>
        <div className="modal-background" onClick={this._handleClose} />
        <div className="modal-card">
          {enableTopRightClose && (
            <button
              className="modal-close is-large"
              aria-label="close"
              onClick={this._handleClose}
            />
          )}
          {header && (
            <header className="modal-card-head">
              <h2 className={'text--header'}>{header}</h2>
            </header>
          )}
          <section
            className={cn('modal-card-body', header && 'modal-card-body--edge')}
          >
            {children}
          </section>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  enableTopRightClose: PropTypes.bool,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onToggle: PropTypes.func,
  theme: PropTypes.array,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/common/components/Modal/index.js